import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "../lib/api";

export const Stars = ({ value, size = "h-4 w-4" }) => (
  <span className="inline-flex" aria-label={`${value} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((n) => <Star key={n} className={`${size} ${n <= Math.round(value) ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />)}
  </span>
);

let cache;
export const useReviews = () => {
  const [d, setD] = useState(cache || null);
  useEffect(() => { if (!cache) api.get("/reviews").then((r) => { cache = r.data; setD(r.data); }).catch(() => {}); }, []);
  return d;
};

export const withRatingLd = (product, rv) => (!rv?.count ? product : {
  ...product,
  aggregateRating: { "@type": "AggregateRating", ratingValue: rv.average, reviewCount: rv.count, bestRating: 5, worstRating: 1 },
  review: rv.reviews.slice(0, 5).map((r) => ({ "@type": "Review", reviewRating: { "@type": "Rating", ratingValue: r.rating, bestRating: 5 }, author: { "@type": "Person", name: r.display_name }, reviewBody: r.text || undefined, datePublished: r.submitted_at?.slice(0, 10) })),
});

export const ReviewStrip = ({ compact = false }) => {
  const d = useReviews();
  if (!d?.count) return null;
  const list = d.reviews.filter((r) => r.text).slice(0, compact ? 2 : 3);
  return (
    <section className={compact ? "border-2 border-slate-900 bg-white p-4" : "mx-auto max-w-6xl px-4 pb-16 sm:px-6"} data-testid="review-strip">
      {!compact && <h2 className="font-display mb-2 text-2xl font-black uppercase" data-testid="review-heading">What customers say</h2>}
      <div className="flex flex-wrap items-center gap-2">
        <Stars value={d.average} size={compact ? "h-4 w-4" : "h-6 w-6"} />
        <span className="font-bold" data-testid="review-average">{d.average} / 5</span>
        <span className="text-sm text-slate-600">from {d.count} customer review{d.count === 1 ? "" : "s"}</span>
      </div>
      <div className={`mt-3 grid gap-3 ${compact ? "" : "sm:grid-cols-3"}`}>
        {list.map((r) => (
          <figure key={r.id} className="border-2 border-slate-200 bg-white p-3 text-sm" data-testid={`review-${r.id}`}>
            <Stars value={r.rating} size="h-3.5 w-3.5" />
            <blockquote className="mt-1 text-slate-700">“{r.text}”</blockquote>
            <figcaption className="mt-1 text-xs font-bold text-slate-500">{r.display_name}{r.location ? `, ${r.location}` : ""}</figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};
